import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function AbstractPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Abstract</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Urbanisation is associated with large scale irreversible landscape
              changes in response to the demands of burgeoning population, etc.
              Lack of basic amenities, job and infrastructures in rural areas
              often drives migration towards the urbanizing landscapes.
              Urbanisation is resource centric, which involves, large-scale
              transformation of the landscape with the irreversible impacts on
              the regional ecology, hydrology and environment, which is evident
              from large-scale land cover changes leading to deforestation,
              encroachment of lakes/water bodies, forest and farmlands,
              conversion of agriculture landscapes, <em>etc.</em> damaging the
              environs. Visualization of urban growth based on the past spatial
              patterns would help in evolving appropriate policy framework
              towards the design of sustainable cites for the prudent management
              of natural resources. Current communication attempts to understand
              the landscape dynamics along the proposed Mumbai Pune industrial
              corridor (with 10 km buffer) through (i) Rule based/Non Agent
              Based Models (non-ABM) and (ii) Agent Based Models (ABM) with the
              evaluation of relative performance of ABM and Non-ABM methods.
              Comparative assessment of the model performance through accuracy
              assessment and Kappa (relatively significant at p&lt;0.05)
              indicates the superior performance of the Agent based model
              approaches due to its interaction with factors and constraints
              that allow urban growth in the region. Non-ABM model predicted the
              growth of 49.69% by 2027 with the decline of vegetation to 9.63%,
              Compared to this, Agent based model predicted growth in urban
              landscape to 47.12% and the decline of vegetation to 11.10%. The
              current research was formulated based on the recommendations of
              the deliberation between academia and stakeholder industries who
              are likely to be benefitted by the implementation of the
              industrial corridor. The research outcome also helps local
              planning authorities in advance visualization of urban dynamics to
              design sustainable urban regions with the provision of appropriate
              infrastructure and basic amenities.
            </p>
            <p>
              <strong>
                <em>Keywords</em>
              </strong>
              <em>
                : Urbanisation, Landscape dynamics, Remote Sensing, Modelling,
                Visualisation
              </em>
            </p>

            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default AbstractPage;
